import {Breakpoints, styled} from '@vw-marketing/us-components';

const customLineTittleClass = 'customLineTitle';

export const StyledCarFaxWrapper: any = styled.div`
  width: 100%;
  @media (min-width: ${Breakpoints.b1280}px) {
    margin-top: 0px;
    padding-left: 0px;
  }

  ${`.${customLineTittleClass} {
    font-size: 13px;
    line-height: 1.54;

    @media (min-width: ${Breakpoints.b1280}px) {
      font-size: 16px;
      line-height: 1.25;
    }
  }`}
`;

export const StyledLineContainer: any = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-width: 1px;
  border-style: solid;
  border-color: #cfcfcf;
  border-image: initial;
  border-radius: 10px;
  transition: transform 0.3s cubic-bezier(0.14, 1.12, 0.67, 0.99) 0s;
`;

export const StyledLineTitle: any = styled.div`
  position: absolute;
  top: 0px;
  left: ${(props) => props.theme.size.grid001};
  transform: translateY(-50%);
  background-color: rgb(255, 255, 255);
  opacity: 1;
  padding: 0px 16px;
  transition: opacity 0.3s cubic-bezier(0.14, 1.12, 0.67, 0.99) 0s;
`;

export const StyledContent: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 24px 31px 30px;
  width: 100%;

  @media (min-width: ${Breakpoints.b960}px) {
    padding: 41px 52px 30px;
    gap: 28px;
  }
`;

export const StyledDescriptionContainer = styled.div`
  * {
    font-family: 'vw-text';
    font-weight: 300;
    font-size: 14px;
    line-height: 17px;
  }
`;
